// Preact and Redux
// import 'preact/debug' // Enable for debugging
import {h, render} from 'preact'
import {Provider} from 'react-redux'
// Redux store
import store from './checkout/redux/store'
// App
import App from './checkout/App'

const checkout = document.getElementById('checkout')
const csrfKey = checkout.dataset.csrfKey
const csrfVal = checkout.dataset.csrfVal

render(<Provider store={store}><App csrfKey={csrfKey} csrfVal={csrfVal} /></Provider>, checkout)


// WEBPACK FOOTER //
// ./client/resources/js/checkout.js